import { useSelector } from 'react-redux';
import { selectUser } from 'gossamer-front-end';
import { ConditionElement, Filter, QueryOptions } from 'gossamer-unified';
import { CustomInfo } from 'cb-unified';

/**
 * Ensure the 1st passed-in filter on fieldId institution_id is correctly set based on user role and adminInstitutionId
 * Throw an error if there is no such filter passed in. Does NOT cause re-render. Intended to be used to modify the initial
 * state, to be passed to e.g. useQueryOptionsFromSearchParams()
 */

export const useInstitutionFilter = (queryOptions: QueryOptions) => {
  const user = useSelector(selectUser);
  const adminInstitutionId = (user?.customInfo as CustomInfo | undefined)?.adminInstitutionId;
  const currentFilters = queryOptions.where?.and as ConditionElement[];
  if (!currentFilters) {
    throw new Error('No filters found');
  }
  const instFilter = currentFilters.find((c) => (c as Filter)?.fieldId === 'institution_id') as Filter;
  if (!instFilter) {
    throw new Error('No filter found for institution_id');
  }
  instFilter.display = user?.roleId === 'staff' ? 'value-edit' : 'hidden';
  instFilter.value = adminInstitutionId || '';
  return queryOptions;
};
